/**
 * Maps a frontend asset subtype value to the core asset NAME used in backend API URLs.
 * Most subtypes map 1:1; only exceptions are listed here.
 */
const SUBTYPE_OVERRIDES: Record<string, string> = {
  fieldprm: 'field_prm',
  router: 'network',
  switch: 'network',
  firewall: 'network',
  timeserver: 'network',
};

export function subtypeToCoreAssetName(subtype: string): string {
  return SUBTYPE_OVERRIDES[subtype] ?? subtype;
}

/**
 * Maps API subtype values (from list response) to config keys for asset config lookup.
 * Only needed when the API returns a different value than the frontend config key (e.g. field type "prm" -> "fieldprm").
 */
const API_SUBTYPE_TO_CONFIG_KEY: Record<string, Record<string, string>> = {
  field: { prm: 'fieldprm' },
};

export function apiSubtypeToConfigKey(assetType: string, apiSubtype: string): string {
  return API_SUBTYPE_TO_CONFIG_KEY[assetType]?.[apiSubtype] ?? apiSubtype;
}
